query SearchTrainingOutOfScope($page: Int, $limit: Int, $search: String) {
  searchTrainingOutOfScope(page: $page, limit: $limit, search: $search) {
    collection {
      id
      name
      email
      title
    }
    metadata {
      totalPages
      totalCount
      currentPage
      limitValue
    }
  }
}
